// @flow

import ReactGA from 'react-ga';
import * as React from 'react';
import { MALL_MAP } from '../path/mallPath';
import { STORE_INFO } from '../path/storePath';
import { currentUser, isUserLoggedOn } from '../network/samlService';
import type { SamlToken } from '../types/samlType';

let gaIsInitialize = false;

const geminiApp = 'Gemini';
const turanApp = 'Turan';
const apolloApp = 'Apollo';

type Props = {
  location: Location
}

export const trackPageMap = (isAuthorisedGemini: boolean) => {
  if (gaIsInitialize) {
    ReactGA.set({
      screenName: MALL_MAP,
      appName: isAuthorisedGemini ? geminiApp : turanApp,
    });
    ReactGA.pageview(MALL_MAP);
  }
};

export const trackAnchor = (anchor: string) => {
  if (gaIsInitialize) {
    ReactGA.set({
      screenName: anchor,
    });
    ReactGA.pageview(anchor);
  }
};


export const trackAction = (action: string) => {
  if (gaIsInitialize) {
    ReactGA.set({
      screenName: action,
    });
    ReactGA.pageview(action);
  }
};
// This function takes a component...
export default function googleAnalytics(WrappedComponent: Function, promise: Promise<String>) {
  const getAppName = (page) => {
    if (page.startsWith(MALL_MAP)) {
      return null;
    } else if (page.startsWith(STORE_INFO)) {
      return apolloApp;
    }
    return turanApp;
  };

  const trackPage = (page) => {
    if (gaIsInitialize) {
      const appName = getAppName(page);
      if (!appName) {
        return;
      }
      ReactGA.set({
        screenName: page,
        appName,
      });
      ReactGA.pageview(page);
    }
  };

  promise.then((token) => {
    if (token && token !== '') {
      gaIsInitialize = true;
      ReactGA.initialize({
        trackingId: token,
      });
      if (isUserLoggedOn()) {
        const user: SamlToken = currentUser().activeUser;
        ReactGA.set({
          dimension1: user.department,
          dimension2: user.country,
        });
      }
      ReactGA.pageview(window.location.pathname);
    }
  });

  return class extends React.PureComponent<Props> {
    componentDidUpdate(prevProps: Props) {
      const prevUrl = `${prevProps.location.pathname}${prevProps.location.search}`;
      const newUrl = `${this.props.location.pathname}${this.props.location.search}`;
      if (prevUrl !== newUrl) {
        trackPage(newUrl);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
